import React from "react"
import CustBreadcrumb from "components/CustBreadcrumb"

export default function HolidayBreadcrumb({ name }) {
  return <CustBreadcrumb links={[["Settings", "/settings"], ["Manage Public Holidays", "/settings/manage-holidays"]]} active={name} />
}
